import gql from 'graphql-tag'
import client from '@stores/apollo'

interface AddFloorToManagedLocationsInput {
  id: string
  floorPlanId: string
}

export default function addFloorToManagedLocations(
  input: AddFloorToManagedLocationsInput
): Promise<any> {
  return client.gql.mutate({ mutation, variables: { input } })
}

const mutation = gql`
  mutation addFloorToManagedLocations($input: AddLocationAdminEmployeeInput!) {
    addLocationAdminEmployee(input: $input) {
      employee {
        id
      }
    }
  }
`
